import React from 'react';
import styled from 'styled-components';
import {convertToDecimal} from '../../AccountOverview/index';
import {displayValue} from '../../AccountOverview/indexDisplayValue';
import {isNullOrUndefined} from '../../../../../../../../util/utils';
import {useUserPreferences} from '../../../../../../../../util/customHooks';
import {IconoirArrowUp, IconoirArrowDown} from '@ey-xd/motif-icon';

export default function BalanceArrow(params) {
	let value = !isNullOrUndefined(params.value) ? convertToDecimal(params.value, false, false) : 0;
	if (value > 9999) {
		value = '9999';
	} else if (value < -9999) {
		value = '-9999';
	}

	const userPreferences = useUserPreferences();
	const numberFormated = displayValue(
		value,
		false,
		true,
		true,
		'%',
		1,
		undefined,
		undefined,
		undefined,
		userPreferences,
		IconoirArrowUp,
		IconoirArrowDown
	);

	return <StyledBalanceArrow className="StyledBalanceArrow">{numberFormated}</StyledBalanceArrow>;
}

const StyledBalanceArrow = styled.section`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-22);
	width: 100%;
	.DisplayAmount {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		width: 100%;
		.ellipses {
			width: auto;
			max-width: calc(100% - var(--px-20));
			div {
				display: inline-flex;
				span {
					display: inline-block;
					width: 100%;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				}
			}
		}
		.motif-icon {
			display: inline-flex;
			width: var(--px-16);
			margin: 0 0 0 var(--px-4);
			svg {
				height: var(--px-16) !important;
				width: var(--px-16) !important;
				cursor: default !important;
				vertical-align: middle;
			}
			&.red-arrow {
				svg {
					color: var(--red-400) !important;
					fill: none !important;
				}
			}
			&.green-arrow {
				svg {
					color: var(--green-300) !important;
					fill: none !important;
				}
			}
		}
	}
`;
